import axios from 'axios'
import store from '../../store/index'

const state = {
  appSettings: {},
}

const mutations = {
}

const actions = {
  getAppCurrency ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appCurrency',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
